<template>
	<section v-if="contentText.title" class="content-text-container has-angular-divider">
		<div class="content-text">
			<div class="container">
				<h2 class="heading" v-html="sanitizeTitle(contentText.title)"></h2>
				<div v-if="contentText.text" class="content-text-description">
					<RichText :content="contentText.text.content" />
				</div>
			</div>
		</div>

		<div class="angular-divider">
			<div class="angular-divider-image"></div>
		</div>
	</section>
</template>

<script setup>
import {useSanitize} from "~~/composables/useSanitize.js";
const { sanitizeTitle } = useSanitize();
const  { content } = defineProps({
	content: {
		type: Object,
		required: true
	}
});

const contentText = computed(() => content ?? {});
</script>

<style lang="scss">
@use '~/assets/scss/components/ContentText.scss';
</style>